import React from 'react';
import { DocPageLayout } from '../../components/DocPageLayout';
import { CodeBlock } from '../../components/CodeBlock';
import { InfoBox } from '../../components/InfoBox';
export function ApiBatchPage() {
  return <DocPageLayout title="Batch API" description="Submit batches of operations (Captures, Refunds, etc) to the Gateway for processing without direct payer interaction." breadcrumbs={[{
    label: 'API Reference',
    id: 'api-overview'
  }, {
    label: 'Batch'
  }]} sections={[{
    id: 'submit-batch',
    title: 'Submit Batch'
  }, {
    id: 'retrieve-batch',
    title: 'Retrieve Batch Status'
  }, {
    id: 'batch-status-values',
    title: 'Batch Status Values'
  }]} data-id="element-442">
      <h2 id="submit-batch" className="text-2xl font-bold text-gray-900 mt-6 mb-4 border-b border-gray-200 pb-2" data-id="element-443">
        Submit Batch
      </h2>
      <div className="bg-gray-50 p-4 rounded-lg border border-gray-200 mb-6 font-mono text-sm" data-id="element-444">
        <span className="inline-block px-2 py-0.5 rounded-full text-xs font-bold bg-amber-100 text-amber-700 mr-2" data-id="element-445">
          PUT
        </span>
        <span className="text-gray-600" data-id="element-446">/merchant/</span>
        <span className="text-blue-600" data-id="element-447">{'{merchantId}'}</span>
        <span className="text-gray-600" data-id="element-448">/batch/</span>
        <span className="text-blue-600" data-id="element-449">{'{batchId}'}</span>
      </div>
      <CodeBlock language="JSON" title="Request" code={`{
  "apiOperation": "PAY",
  "transaction": [
    {
      "order": { "id": "BATCH-001", "amount": "25.00", "currency": "USD" },
      "sourceOfFunds": { "token": "9111111111111111" }
    },
    {
      "order": { "id": "BATCH-002", "amount": "50.00", "currency": "USD" },
      "sourceOfFunds": { "token": "9222222222222222" }
    }
  ]
}`} data-id="element-450" />

      <h2 id="retrieve-batch" className="text-2xl font-bold text-gray-900 mt-10 mb-4 border-b border-gray-200 pb-2" data-id="element-451">
        Retrieve Batch Status
      </h2>
      <div className="bg-gray-50 p-4 rounded-lg border border-gray-200 mb-6 font-mono text-sm" data-id="element-452">
        <span className="inline-block px-2 py-0.5 rounded-full text-xs font-bold bg-green-100 text-green-700 mr-2" data-id="element-453">
          GET
        </span>
        <span className="text-gray-600" data-id="element-454">/merchant/</span>
        <span className="text-blue-600" data-id="element-455">{'{merchantId}'}</span>
        <span className="text-gray-600" data-id="element-456">/batch/</span>
        <span className="text-blue-600" data-id="element-457">{'{batchId}'}</span>
      </div>
      <CodeBlock language="JSON" title="Response" code={`{
  "id": "BATCH-20260308",
  "status": "COMPLETED",
  "totalCount": 2,
  "successCount": 2,
  "failedCount": 0,
  "processingTime": "2026-03-08T14:30:00.000Z"
}`} data-id="element-458" />

      <h2 id="batch-status-values" className="text-2xl font-bold text-gray-900 mt-10 mb-4" data-id="element-459">
        Batch Status Values
      </h2>
      <div className="overflow-x-auto mb-8" data-id="element-460">
        <table className="w-full text-sm border border-gray-200 rounded-lg overflow-hidden" data-id="element-461">
          <thead data-id="element-462">
            <tr className="bg-gray-100" data-id="element-463">
              <th className="text-left px-4 py-3 font-semibold border-b" data-id="element-464">
                Status
              </th>
              <th className="text-left px-4 py-3 font-semibold border-b" data-id="element-465">
                Description
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200" data-id="element-466">
            <tr data-id="element-467">
              <td className="px-4 py-3 font-mono text-xs" data-id="element-468">PENDING</td>
              <td className="px-4 py-3 text-gray-600" data-id="element-469">
                Batch has been submitted and is awaiting processing
              </td>
            </tr>
            <tr className="bg-gray-50" data-id="element-470">
              <td className="px-4 py-3 font-mono text-xs" data-id="element-471">PROCESSING</td>
              <td className="px-4 py-3 text-gray-600" data-id="element-472">
                Batch is currently being processed
              </td>
            </tr>
            <tr data-id="element-473">
              <td className="px-4 py-3 font-mono text-xs" data-id="element-474">COMPLETED</td>
              <td className="px-4 py-3 text-gray-600" data-id="element-475">
                All operations in the batch have been processed
              </td>
            </tr>
            <tr className="bg-gray-50" data-id="element-476">
              <td className="px-4 py-3 font-mono text-xs" data-id="element-477">
                PARTIALLY_COMPLETED
              </td>
              <td className="px-4 py-3 text-gray-600" data-id="element-478">
                Some operations succeeded, some failed
              </td>
            </tr>
            <tr data-id="element-479">
              <td className="px-4 py-3 font-mono text-xs" data-id="element-480">FAILED</td>
              <td className="px-4 py-3 text-gray-600" data-id="element-481">
                The batch could not be processed
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <InfoBox type="info" title="Batch Limits" data-id="element-482">
        Maximum 1,000 operations per batch. For larger volumes, split across
        multiple batch submissions.
      </InfoBox>
    </DocPageLayout>;
}